// extracted by mini-css-extract-plugin
export var linkButton = "index-module--linkButton--YVJ64";
export var text = "index-module--text--iRR98";